<template>
    <div>
        <!-- Modal Component -->
        <b-modal id="modal_associar"
                 ref="modal_associar"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 v-model="showModalAssociar"
                 size="lg"
                 :ok-disabled=form.errors.any()
                 @ok="onStoreAssociarDoc">
                 <b-container fluid>
                     <b-row>
                         <b-col md="4" sm="6" class="p-0">
                             <label>Container</label>
                             <b-form-input type="text"
                                     placeholder="Container"
                                     v-model="form.num_container"
                                     >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('num_container')" v-if="form.errors.has('num_container')"></b-form-feedback>
                         </b-col>
                         <b-col md="4" sm="6" class="p-0">
                             <label>Lacre</label>
                             <b-form-input type="text"
                                     placeholder="Lacre"
                                     v-model="form.num_lacre"
                                     >
                             </b-form-input>
                             <b-form-feedback class="text-danger" v-text="form.errors.get('num_lacre')" v-if="form.errors.has('num_lacre')"></b-form-feedback>
                         </b-col>
                         <b-col md="4" sm="12" class="p-0">
                             <label>Observação</label>
                            <b-form-input type="text"
                                     placeholder="Observação"
                                     v-model="form.obs"
                                     >
                            </b-form-input>
                        </b-col>
                     </b-row>
                     <b-row class="m-t-5px p-0">
                         <table class="table table-striped">
                             <thead>
                                 <tr>
                                     <th style="width: 5%">Tipo</th>
                                     <th style="width: 20%">Doc Carga - Emitente</th>
                                     <th style="width: 25%">Chave</th>
                                     <th style="width: 10%">Nº Fiscal</th>
                                     <th style="width: 10%">Série</th>
                                     <th style="width: 15%">Data</th>
                                     <th style="width: 5%">Ação</th>
                                 </tr>
                              </thead>
                              <tbody>
                                  <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfis">
                                     <td>
                                         {{ row.tp_doc.descr }}
                                     </td>
                                     <td>
                                         {{ row.emi_nome }}
                                     </td>
                                     <td>
                                         <span v-if="row.tp_doc.valor==1">
                                            {{ row.chave }}
                                         </span>
                                     </td>
                                     <td>
                                         {{ row.num_fiscal }}
                                     </td>
                                     <td>
                                         {{ row.serie }}
                                     </td>
                                     <td>
                                         <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                     </td>
                                     <td>
                                         <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDoc(index);"></i>
                                     </td>
                                 </tr>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfisDig">
                                    <td>
                                         {{ row.tp_doc_descr }}
                                    </td>
                                    <td>
                                        {{ row.emi_nome }}
                                    </td>
                                    <td>
                                        <span v-if="row.tp_doc.valor==1">
                                           {{ row.chave }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ row.num_fiscal }}
                                    </td>
                                    <td>
                                        {{ row.serie }}
                                    </td>
                                    <td>
                                        <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                    </td>
                                    <td>
                                        <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDocDig(index);"></i>
                                    </td>
                                </tr>
                             </tbody>
                         </table>
                    </b-row>

                    <b-row class="m-t-5px p-0">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 5%">Tipo</th>
                                    <th style="width: 20%">Doc Anterior - Emitente</th>
                                    <th style="width: 25%">Chave</th>
                                    <th style="width: 10%">Nº Fiscal</th>
                                    <th style="width: 10%">Série</th>
                                    <th style="width: 15%">Data</th>
                                    <th style="width: 5%">Ação</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in doctransp">
                                    <td>
                                        {{ row.tp_doc.descr }}
                                    </td>
                                    <td>
                                        {{ row.emi_nome }}
                                    </td>
                                    <td>
                                        <span v-if="row.tp_doc.valor==1">
                                           {{ row.chave }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ row.num_fiscal }}
                                    </td>
                                    <td>
                                        {{ row.serie }}
                                    </td>
                                    <td>
                                        <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                    </td>
                                    <td>
                                        <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDocTransp(index);"></i>
                                    </td>
                                </tr>
                                <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in doctranspDig">
                                   <td>
                                        {{ row.tp_doc_descr }}
                                   </td>
                                   <td>
                                       {{ row.emi_nome }}
                                   </td>
                                   <td>
                                       <span v-if="row.tp_doc.valor==1">
                                          {{ row.chave }}
                                       </span>
                                   </td>
                                   <td>
                                       {{ row.num_fiscal }}
                                   </td>
                                   <td>
                                       {{ row.serie }}
                                   </td>
                                   <td>
                                       <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                   </td>
                                   <td>
                                       <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDocTranspDig(index);"></i>
                                   </td>
                               </tr>
                            </tbody>
                        </table>
                   </b-row>

                    <b-row class="m-t-5px p-0">
                        <b-tabs style="width: 100%" fill>
                            <b-tab title="NFe" active>
                                <b-container fluid>
                                    <b-row class="m-t-5px p-0">
                                        <b-col sm="12" md="12" class="p-0">
                                            Chave:
                                        </b-col>
                                    </b-row>
                                    <b-row class="m-t-15px p-0">
                                        <b-col sm="9" md="9" class="p-0">
                                            <b-form-input type="text"
                                                         placeholder="Chave"
                                                         v-model="helpForm.chave"
                                                         >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                        </b-col>
                                        <b-col sm="3" md="3" class="p-0">
                                            <div class="input-group-btn">
                                                <div class="btn-group">
                                                    <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDoc($event);" v-b-tooltip.hover.right="'Adicionar NFe'" style="cursor: pointer">
                                                    Adicionar
                                                    </b-btn>

                                                    <b-btn variant="secondary" :disabled="isDisabled" v-on:click="onBuscarDoc();" v-b-tooltip.hover.right="'Buscar Doc'" style="cursor: pointer">
                                                    Buscar
                                                    </b-btn>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </b-tab>

                            <b-tab title="Outros Documentos de Carga ( Digitação )">
                                <table class="table-striped">
                                    <tbody>
                                        <tr class="bg-gray-light" style="display: table-row;">
                                           <td>
                                               <b-container fluid class="p-0">
                                                   <b-row no-gutters>
                                                       <label><strong>Emitente Documento</strong></label>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Tipo *</label>
                                                         <multiselect v-model="helpForm.emi_tp_pessoa"
                                                         :options="optionsLivTpPessoa"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_tp_pessoa.value')" v-if="helpForm.errors.has('emi_tp_pessoa.value')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                           <label>CNPJ/CPF/CUIT</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CNPJ/CPF/CUIT"
                                                                         v-model="helpForm.emi_cnpj_cpf_cuit"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_cnpj_cpf_cuit')" v-if="helpForm.errors.has('emi_cnpj_cpf_cuit')"></b-form-feedback>
                                                       </b-col>
                                                       <b-col sm="8" md="8" class="m-t-5px p-0">
                                                           <label>Nome</label>
                                                           <b-form-input type="text"
                                                                       placeholder="Nome"
                                                                       v-model="helpForm.emi_nome"
                                                                       >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_nome')" v-if="helpForm.errors.has('emi_nome')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>CEP *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="CEP"
                                                                       @change="getCep(1)"
                                                                       v-model="helpForm.emi_cep"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_cep')" v-if="helpForm.errors.has('emi_cep')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Municipio *</label>
                                                         <multiselect v-model="helpForm.emi_municipio"
                                                         :options="optionsMunicipios"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_municipio.value')" v-if="helpForm.errors.has('emi_municipio.value')"></b-form-feedback>
                                                       </b-col>


                                                       <b-col sm="3" md="3" class="m-t-5px p-0">
                                                         <label>Endereço *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Endereço"
                                                                       v-model="helpForm.emi_endereco"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_endereco')" v-if="helpForm.errors.has('emi_endereco')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Número *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Número"
                                                                       v-model="helpForm.emi_numero"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_numero')" v-if="helpForm.errors.has('emi_numero')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Bairro *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Bairro"
                                                                       v-model="helpForm.emi_bairro"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_bairro')" v-if="helpForm.errors.has('emi_bairro')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Complemento</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Complemento"
                                                                       v-model="helpForm.emi_complemento"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_complemento')" v-if="helpForm.errors.has('emi_complemento')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>

                                                   <b-row no-gutters>
                                                       <label><strong>Destinatário Documento</strong></label>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Tipo *</label>
                                                         <multiselect v-model="helpForm.des_tp_pessoa"
                                                         :options="optionsLivTpPessoa"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_tp_pessoa.value')" v-if="helpForm.errors.has('des_tp_pessoa.value')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                           <label>CNPJ/CPF/CUIT</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CNPJ/CPF/CUIT"
                                                                         v-model="helpForm.des_cnpj_cpf_cuit"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_cnpj_cpf_cuit')" v-if="helpForm.errors.has('des_cnpj_cpf_cuit')"></b-form-feedback>
                                                       </b-col>
                                                       <b-col sm="6" md="6" class="m-t-5px p-0">
                                                           <label>Nome</label>
                                                           <b-form-input type="text"
                                                                       placeholder="Nome"
                                                                       v-model="helpForm.des_nome"
                                                                       >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_nome')" v-if="helpForm.errors.has('des_nome')"></b-form-feedback>
                                                       </b-col>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>PIN Suframa</label>
                                                         <b-form-input type="text"
                                                                       placeholder="PIN"
                                                                       v-model="helpForm.des_pin"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_pin')" v-if="helpForm.errors.has('des_pin')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>CEP *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="CEP"
                                                                       @change="getCep(2)"
                                                                       v-model="helpForm.des_cep"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_cep')" v-if="helpForm.errors.has('des_cep')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Municipio *</label>
                                                         <multiselect v-model="helpForm.des_municipio"
                                                         :options="optionsMunicipios"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_municipio.value')" v-if="helpForm.errors.has('des_municipio.value')"></b-form-feedback>
                                                       </b-col>


                                                       <b-col sm="3" md="3" class="m-t-5px p-0">
                                                         <label>Endereço *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Endereço"
                                                                       v-model="helpForm.des_endereco"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_endereco')" v-if="helpForm.errors.has('des_endereco')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Número *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Número"
                                                                       v-model="helpForm.des_numero"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_numero')" v-if="helpForm.errors.has('des_numero')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Bairro *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Bairro"
                                                                       v-model="helpForm.des_bairro"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_bairro')" v-if="helpForm.errors.has('des_bairro')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Complemento</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Complemento"
                                                                       v-model="helpForm.des_complemento"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_complemento')" v-if="helpForm.errors.has('des_complemento')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>

                                                   <b-row no-gutters>
                                                       <label><strong>Detalhes</strong></label>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Tipo *</label>
                                                         <multiselect v-model="helpForm.tp_doc"
                                                         :options="optionsLivDocFiscalTpDoc"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('tp_doc.value')" v-if="helpForm.errors.has('tp_doc.value')"></b-form-feedback>
                                                       </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Nº Fiscal *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Nº Fiscal"
                                                                       v-model="helpForm.num_fiscal"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('num_fiscal')" v-if="helpForm.errors.has('num_fiscal')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Série *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Série"
                                                                       v-model="helpForm.serie"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('serie')" v-if="helpForm.errors.has('serie')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Chave</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Chave"
                                                                       v-model="helpForm.chave"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Data *</label>
                                                         <v-date-picker v-model="helpForm.dt_emissao"
                                                                        mode='single'
                                                                        locale="pt-BR"
                                                                        v-mask="'##/##/####'"
                                                                        :popover='{visibility: "focus"}'
                                                                        :attributes='date_attributes'
                                                                        :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                                                        @keyup.enter="doFilter">
                                                         </v-date-picker>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('dt_emissao')" v-if="helpForm.errors.has('dt_emissao')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Volume *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Volume"
                                                                       v-model="helpForm.qtd_volume"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('qtd_volume')" v-if="helpForm.errors.has('qtd_volume')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Peso Bruto *</label>
                                                         <b-form-input type="text"
                                                                       v-money="qtd"
                                                                       placeholder="Peso Bruto"
                                                                       v-model="helpForm.peso_bruto"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('peso_bruto')" v-if="helpForm.errors.has('peso_bruto')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Valor Doc. *</label>
                                                         <b-form-input type="text"
                                                                       v-money="vlr"
                                                                       placeholder="Valor Documento"
                                                                       v-model="helpForm.vlr_total_nfe"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('vlr_total_nfe')" v-if="helpForm.errors.has('vlr_total_nfe')"></b-form-feedback>
                                                     </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col sm="10" md="10">
                                                        </b-col>
                                                        <b-col sm="2" md="2" class="text-right">
                                                            <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocDigitacao($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                                                            Adicionar
                                                            </b-btn>
                                                        </b-col>
                                                    </b-row>
                                                </b-container>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-tab>

                            <b-tab title="CTe">
                                <b-container fluid>
                                    <b-row class="m-t-5px p-0">
                                        <b-col sm="12" md="12" class="p-0">
                                            Chave:
                                        </b-col>
                                    </b-row>
                                    <b-row class="m-t-15px p-0">
                                        <b-col sm="9" md="9" class="p-0">
                                            <b-form-input type="text"
                                                         placeholder="Chave CTe"
                                                         v-model="form_doctransp.chave"
                                                         >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('chave')" v-if="form_doctransp.errors.has('chave')"></b-form-feedback>
                                        </b-col>
                                        <b-col sm="3" md="3" class="p-0">
                                            <div class="input-group-btn">
                                                <div class="btn-group">
                                                    <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocTransp($event);" v-b-tooltip.hover.right="'Adicionar CTe'" style="cursor: pointer">
                                                    Adicionar
                                                    </b-btn>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </b-tab>

                            <b-tab title="Documentos Anteriores ( Digitação )">
                                <table class="table-striped">
                                    <tbody>
                                        <tr class="bg-gray-light" style="display: table-row;">
                                           <td>
                                               <b-container fluid class="p-0">
                                                   <b-row no-gutters>
                                                       <label><strong>Emitente Documento</strong></label>
                                                   </b-row>
                                                   <b-row no-gutters>

                                                       <b-col sm="3" md="3" class="m-t-5px p-0">
                                                           <label>CNPJ</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CNPJ"
                                                                         v-model="form_doctransp.emi_cnpj_cpf_cuit"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_cnpj_cpf_cuit')" v-if="form_doctransp.errors.has('emi_cnpj_cpf_cuit')"></b-form-feedback>
                                                       </b-col>
                                                       <b-col sm="9" md="9" class="m-t-5px p-0">
                                                           <label>Nome</label>
                                                           <b-form-input type="text"
                                                                       placeholder="Nome"
                                                                       v-model="form_doctransp.emi_nome"
                                                                       >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_nome')" v-if="form_doctransp.errors.has('emi_nome')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>CEP *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="CEP"
                                                                       @change="getCep(3)"
                                                                       v-model="form_doctransp.emi_cep"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_cep')" v-if="form_doctransp.errors.has('emi_cep')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Municipio *</label>
                                                         <multiselect v-model="form_doctransp.emi_municipio"
                                                         :options="optionsMunicipios"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_municipio.value')" v-if="form_doctransp.errors.has('emi_municipio.value')"></b-form-feedback>
                                                       </b-col>


                                                       <b-col sm="3" md="3" class="m-t-5px p-0">
                                                         <label>Endereço *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Endereço"
                                                                       v-model="form_doctransp.emi_endereco"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_endereco')" v-if="form_doctransp.errors.has('emi_endereco')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Número *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Número"
                                                                       v-model="form_doctransp.emi_numero"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_numero')" v-if="form_doctransp.errors.has('emi_numero')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Bairro *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Bairro"
                                                                       v-model="form_doctransp.emi_bairro"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_bairro')" v-if="form_doctransp.errors.has('emi_bairro')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Complemento</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Complemento"
                                                                       v-model="form_doctransp.emi_complemento"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_complemento')" v-if="form_doctransp.errors.has('emi_complemento')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>

                                                   <b-row no-gutters>
                                                       <label><strong>Destinatário Documento</strong></label>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Tipo *</label>
                                                         <multiselect v-model="form_doctransp.des_tp_pessoa"
                                                         :options="optionsLivTpPessoa"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_tp_pessoa.value')" v-if="form_doctransp.errors.has('des_tp_pessoa.value')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                           <label>CNPJ/CPF/CUIT</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CNPJ/CPF/CUIT"
                                                                         v-model="form_doctransp.des_cnpj_cpf_cuit"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_cnpj_cpf_cuit')" v-if="form_doctransp.errors.has('des_cnpj_cpf_cuit')"></b-form-feedback>
                                                       </b-col>
                                                       <b-col sm="6" md="6" class="m-t-5px p-0">
                                                           <label>Nome</label>
                                                           <b-form-input type="text"
                                                                       placeholder="Nome"
                                                                       v-model="form_doctransp.des_nome"
                                                                       >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_nome')" v-if="form_doctransp.errors.has('des_nome')"></b-form-feedback>
                                                       </b-col>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>PIN Suframa</label>
                                                         <b-form-input type="text"
                                                                       placeholder="PIN"
                                                                       v-model="form_doctransp.des_pin"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_pin')" v-if="form_doctransp.errors.has('des_pin')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>CEP *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="CEP"
                                                                       @change="getCep(4)"
                                                                       v-model="form_doctransp.des_cep"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_cep')" v-if="form_doctransp.errors.has('des_cep')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Municipio *</label>
                                                         <multiselect v-model="form_doctransp.des_municipio"
                                                         :options="optionsMunicipios"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_municipio.value')" v-if="form_doctransp.errors.has('des_municipio.value')"></b-form-feedback>
                                                       </b-col>


                                                       <b-col sm="3" md="3" class="m-t-5px p-0">
                                                         <label>Endereço *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Endereço"
                                                                       v-model="form_doctransp.des_endereco"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_endereco')" v-if="form_doctransp.errors.has('des_endereco')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Número *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Número"
                                                                       v-model="form_doctransp.des_numero"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_numero')" v-if="form_doctransp.errors.has('des_numero')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Bairro *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Bairro"
                                                                       v-model="form_doctransp.des_bairro"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_bairro')" v-if="form_doctransp.errors.has('des_bairro')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Complemento</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Complemento"
                                                                       v-model="form_doctransp.des_complemento"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_complemento')" v-if="form_doctransp.errors.has('des_complemento')"></b-form-feedback>
                                                       </b-col>
                                                   </b-row>

                                                   <b-row no-gutters>
                                                       <label><strong>Detalhes</strong></label>
                                                   </b-row>
                                                   <b-row no-gutters>
                                                       <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Tipo *</label>
                                                         <multiselect v-model="form_doctransp.tp_doc"
                                                         :options="optionsLivDocTranspTpDoc"
                                                         track-by="value"
                                                         label="label"
                                                         :hide-selected="true"
                                                         placeholder="Selecione"
                                                         tag-placeholder="Selecionar"
                                                         select-label="Selecionar"
                                                         selected-label="Selecionado"
                                                         deselect-label="Remover"
                                                         ></multiselect>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('tp_doc.value')" v-if="form_doctransp.errors.has('tp_doc.value')"></b-form-feedback>
                                                       </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Nº Fiscal *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Nº Fiscal"
                                                                       v-model="form_doctransp.num_fiscal"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('num_fiscal')" v-if="form_doctransp.errors.has('num_fiscal')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Série *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Série"
                                                                       v-model="form_doctransp.serie"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('serie')" v-if="form_doctransp.errors.has('serie')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Chave</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Chave"
                                                                       v-model="form_doctransp.chave"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('chave')" v-if="form_doctransp.errors.has('chave')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Data *</label>
                                                         <v-date-picker v-model="form_doctransp.dt_emissao"
                                                                        mode='single'
                                                                        locale="pt-BR"
                                                                        v-mask="'##/##/####'"
                                                                        :popover='{visibility: "focus"}'
                                                                        :attributes='date_attributes'
                                                                        :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                                                        @keyup.enter="doFilter">
                                                         </v-date-picker>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('dt_emissao')" v-if="form_doctransp.errors.has('dt_emissao')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="1" md="1" class="m-t-5px p-0">
                                                         <label>Volume *</label>
                                                         <b-form-input type="text"
                                                                       placeholder="Volume"
                                                                       v-model="form_doctransp.qtd_volume"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('qtd_volume')" v-if="form_doctransp.errors.has('qtd_volume')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Peso Bruto *</label>
                                                         <b-form-input type="text"
                                                                       v-money="qtd"
                                                                       placeholder="Peso Bruto"
                                                                       v-model="form_doctransp.peso_bruto"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('peso_bruto')" v-if="form_doctransp.errors.has('peso_bruto')"></b-form-feedback>
                                                     </b-col>

                                                     <b-col sm="2" md="2" class="m-t-5px p-0">
                                                         <label>Valor Doc. *</label>
                                                         <b-form-input type="text"
                                                                       v-money="vlr"
                                                                       placeholder="Valor Documento"
                                                                       v-model="form_doctransp.vlr_total_cte"
                                                                       >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('vlr_total_cte')" v-if="form_doctransp.errors.has('vlr_total_cte')"></b-form-feedback>
                                                     </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col sm="10" md="10">
                                                        </b-col>
                                                        <b-col sm="2" md="2" class="text-right">
                                                            <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocTranspDigitacao($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                                                            Adicionar
                                                            </b-btn>
                                                        </b-col>
                                                    </b-row>
                                                </b-container>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-tab>
                        </b-tabs>
                </b-row>
            </b-container>
            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <spinner v-if="loading" message="Associando..."></spinner>
                    <spinner v-if="loadingAddDoc" message="buscando documento..."></spinner>
                    <spinner v-if="loadingCep" message="buscando endereço..."></spinner>
                </div>
                <div class="float-right">
                    <div class="float-left" v-if="this.errors_array.length>0">
                        <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>
                        <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                            <table class="table-striped" id="mais">
                                <tbody>
                                    <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                       <td>
                                         {{ item.erro }}
                                       </td>
                                   </tr>
                               </tbody>
                            </table>
                        </b-popover>
                    </div>
                    &nbsp;

                    <b-btn @click="showModalAssociar=false" variant="secondary">
                         Fechar
                    </b-btn>
                    <b-btn @click="onStoreAssociarDoc($event)" variant="secondary" :disabled="isDisabled">
                         Associar
                    </b-btn>
                </div>
            </div>
        </b-modal>
        <BuscarDocFiscal
        ref="buscardocfiscal">
        </BuscarDocFiscal>
    </div>
</template>

<script>
import BuscarDocFiscal from './BuscarDocFiscal'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import moment from 'moment'


export default {
    components: {
        VMoney,
        BuscarDocFiscal
    },
    data () {
        return {
        date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        showPopover: false,
        loadingAddDoc: false,
        loading: false,
        isDisabled: false,
        loadingData: true,
        loadingCep: false,
        showModal: false,
        showModalAssociar: false,
        optionsLivDocFiscalTpDoc: [],
        optionsLivDocTranspTpDoc: [],
        optionsLivTpPessoa: [],
        optionsMunicipios: [],
        docfis: [],
        docfisDig: [],
        doctransp: [],
        doctranspDig: [],
        errors_array: [],
        form: new Form({ pedunicar_id: '',
                         num_container: '',
                         num_lacre: '',
                         obs: '',
                         docfis: [],
                         docfisDig: [],
                         doctransp: [],
                         doctranspDig: []
                     }),
        helpForm: new Form({statusRecord: [], params: [],search:'', docs: []
                          , chave: ''
                          , emi_tp_pessoa: []
                          , emi_cnpj_cpf_cuit: ''
                          , emi_nome: ''
                          , emi_cep: ''
                          , emi_numero: ''
                          , emi_bairro: ''
                          , emi_endereco: ''
                          , emi_municipio: []
                          , emi_complemento: ''
                          , des_tp_pessoa: []
                          , des_cnpj_cpf_cuit: ''
                          , des_nome: ''
                          , des_cep: ''
                          , des_numero: ''
                          , des_bairro: ''
                          , des_endereco: ''
                          , des_municipio: []
                          , des_complemento: ''
                          , des_pin: ''
                          , tp_doc: []
                          , num_fiscal: ''
                          , serie: ''
                          , dt_emissao: ''
                          , qtd_volume: ''
                          , peso_bruto: 0
                          , vlr_total_nfe: 0
                          , cep_busca: ''
                          }),
        form_doctransp: new Form({ doctransp: []
                                  , chave: ''
                                  , emi_cnpj_cpf_cuit: ''
                                  , emi_nome: ''
                                  , emi_cep: ''
                                  , emi_numero: ''
                                  , emi_bairro: ''
                                  , emi_endereco: ''
                                  , emi_municipio: []
                                  , emi_complemento: ''
                                  , des_tp_pessoa: []
                                  , des_cnpj_cpf_cuit: ''
                                  , des_nome: ''
                                  , des_cep: ''
                                  , des_numero: ''
                                  , des_bairro: ''
                                  , des_endereco: ''
                                  , des_municipio: []
                                  , des_complemento: ''
                                  , des_pin: ''
                                  , tp_doc: []
                                  , num_fiscal: ''
                                  , serie: ''
                                  , dt_emissao: ''
                                  , qtd_volume: ''
                                  , peso_bruto: 0
                                  , vlr_total_cte: 0
                                  , cep_busca: ''}),
        vlr: {
           decimal: ',',
           thousands: '.',
           prefix: 'R$ ',
           precision: 2,
           masked: false /* doesn't work with directive */
        },
        qtd: {
           decimal: ',',
           thousands: '.',
           precision: 3,
           masked: false /* doesn't work with directive */
        },
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
            detailRowClass: 'vuetable-detail-row',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        qtd: VMoney,
    },
    mounted() {
        this.getLivGeral();
      },
    methods: {
        onBuscarDoc(data)     {
            this.$refs.buscardocfiscal.onBuscarDocFiscal(data); // PedidoUnidadeCarga
        },
        addDoc() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.helpForm.docs = this.docfis;
            this.helpForm.dt_emissao = this.formatDateSubmit(this.helpForm.dt_emissao);
            this.helpForm.post('/api/associar/adddoc').then(response =>
            {
                this.docfis.push({
                    id: response.docfis_id,
                    chave: response.chave,
                    num_fiscal: response.num_fiscal,
                    serie: response.serie,
                    dt_emissao: response.dt_emissao,
                    emi_nome: response.doc_fiscal_partes_env.emi_nome,
                    emi_cnpj: response.doc_fiscal_partes_env.emi_cnpj,
                    des_nome: response.doc_fiscal_partes_env.des_nome,
                    des_cnpj: response.doc_fiscal_partes_env.des_cnpj,
                    tp_doc: response.liv_tp_doc,
                    tp_doc_descr: response.liv_tp_doc.label
                });
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                new ReturnApi(errors, this)
            });
        },
        addDocDigitacao() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.helpForm.docs = this.docfis;
            // Chamada backend para validar
            this.helpForm.dt_emissao = this.formatDateSubmit(this.helpForm.dt_emissao);
            this.helpForm.post('/api/associar/adddocdigitacao').then(response =>
            {
                this.docfisDig.push({
                    emi_tp_pessoa: this.helpForm.emi_tp_pessoa,
                    emi_cnpj_cpf_cuit: this.helpForm.emi_cnpj_cpf_cuit,
                    emi_nome: this.helpForm.emi_nome,
                    emi_cep: this.helpForm.emi_cep,
                    emi_numero: this.helpForm.emi_numero,
                    emi_bairro: this.helpForm.emi_bairro,
                    emi_endereco: this.helpForm.emi_endereco,
                    emi_municipio: this.helpForm.emi_municipio,
                    emi_complemento: this.helpForm.emi_complemento,
                    des_tp_pessoa: this.helpForm.des_tp_pessoa,
                    des_cnpj_cpf_cuit: this.helpForm.des_cnpj_cpf_cuit,
                    des_nome: this.helpForm.des_nome,
                    des_cep: this.helpForm.des_cep,
                    des_numero: this.helpForm.des_numero,
                    des_bairro: this.helpForm.des_bairro,
                    des_endereco: this.helpForm.des_endereco,
                    des_municipio: this.helpForm.des_municipio,
                    des_complemento: this.helpForm.des_complemento,
                    tp_doc: this.helpForm.tp_doc,
                    tp_doc_descr: this.helpForm.tp_doc.label,
                    chave: this.helpForm.chave,
                    num_fiscal: this.helpForm.num_fiscal,
                    serie: this.helpForm.serie,
                    dt_emissao: this.helpForm.dt_emissao,
                    qtd_volume: this.helpForm.qtd_volume,
                    peso_bruto: this.helpForm.peso_bruto,
                    vlr_total_nfe: this.helpForm.vlr_total_nfe,
                });

                this.loadingAddDoc = false;

                this.helpForm.reset();
                this.isDisabledAddDoc = false;
                vm.$snotify.success(response.message, response.title);
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
                new ReturnApi(errors, this)
            });
        },
        addDocTransp() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.form_doctransp.doctransp = this.doctransp;
            this.form_doctransp.dt_emissao = this.formatDateSubmit(this.form_doctransp.dt_emissao);
            this.form_doctransp.post('/api/associar/adddoctransp').then(response =>
            {
                this.doctransp.push({
                    id: response.doctransp_id,
                    chave: response.chave,
                    num_fiscal: response.num_doc,
                    serie: response.serie,
                    dt_emissao: response.dt_emissao,
                    emi_nome: response.doc_transp_partes_env.emi_nome,
                    emi_cnpj: response.doc_transp_partes_env.emi_cnpj,
                    des_nome: response.doc_transp_partes_env.des_nome,
                    des_cnpj: response.doc_transp_partes_env.des_cnpj,
                    tp_doc: response.liv_tp_doc,
                    tp_doc_descr: response.liv_tp_doc.label
                });
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                new ReturnApi(errors, this)
            });
        },
        addDocTranspDigitacao() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.form_doctransp.doctransp = this.doctranspDig;
            // Chamada backend para validar
            this.form_doctransp.dt_emissao = this.formatDateSubmit(this.form_doctransp.dt_emissao);
            this.form_doctransp.post('/api/associar/adddoctranspdigitacao').then(response =>
            {
                this.doctranspDig.push({
                    emi_cnpj_cpf_cuit: this.form_doctransp.emi_cnpj_cpf_cuit,
                    emi_nome: this.form_doctransp.emi_nome,
                    emi_cep: this.form_doctransp.emi_cep,
                    emi_numero: this.form_doctransp.emi_numero,
                    emi_bairro: this.form_doctransp.emi_bairro,
                    emi_endereco: this.form_doctransp.emi_endereco,
                    emi_municipio: this.form_doctransp.emi_municipio,
                    emi_complemento: this.form_doctransp.emi_complemento,
                    des_tp_pessoa: this.form_doctransp.des_tp_pessoa,
                    des_cnpj_cpf_cuit: this.form_doctransp.des_cnpj_cpf_cuit,
                    des_nome: this.form_doctransp.des_nome,
                    des_cep: this.form_doctransp.des_cep,
                    des_numero: this.form_doctransp.des_numero,
                    des_bairro: this.form_doctransp.des_bairro,
                    des_endereco: this.form_doctransp.des_endereco,
                    des_municipio: this.form_doctransp.des_municipio,
                    des_complemento: this.form_doctransp.des_complemento,
                    des_pin: this.form_doctransp.des_pin,
                    tp_doc: this.form_doctransp.tp_doc,
                    tp_doc_descr: this.form_doctransp.tp_doc.label,
                    chave: this.form_doctransp.chave,
                    num_fiscal: this.form_doctransp.num_fiscal,
                    serie: this.form_doctransp.serie,
                    dt_emissao: this.form_doctransp.dt_emissao,
                    qtd_volume: this.form_doctransp.qtd_volume,
                    peso_bruto: this.form_doctransp.peso_bruto,
                    vlr_total_cte: this.form_doctransp.vlr_total_cte
                });

                this.loadingAddDoc = false;

                this.form_doctransp.reset();
                this.isDisabledAddDoc = false;
                vm.$snotify.success(response.message, response.title);
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
                new ReturnApi(errors, this)
            });
        },
        onAssociarDoc (data) {
            this.modal_titulo = "Associar Documentos";
            this.modal_botao = "Associar";
            this.modal_acao = "i";
            this.showModalAssociar = true;
            this.loadingAddDoc = false;
            this.isDisabledAddDoc = false;
            this.docfis = null;
            this.docfis = [];
            this.errors_array = null;
            this.errors_array = [];
            this.docfisDig = null;
            this.docfisDig = [];
            this.doctransp = null;
            this.doctransp = [];
            this.doctranspDig = null;
            this.doctranspDig = [];
            this.form.reset();
            this.form.pedunicar_id = data.rowData.pedunicar_id;
            if(data.rowData.carga_doc_unidade_carga.length==0)
            {
                this.form.num_container = data.rowData.num_container;
                this.form.num_lacre = data.rowData.num_lacre;
                this.form.obs = data.rowData.obs;
            }
            else
            {
                this.form.num_container = data.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.num_container;
                this.form.num_lacre = data.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.num_lacre;
                this.form.obs = data.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.obs;
            }

            if(data.rowData.carga_doc_unidade_carga.length>=1)
            {
                data.rowData.carga_doc_unidade_carga.forEach((obj)=>{
                    obj.carga_doc.forEach((obj2)=>{
                        if(obj2.doc_fiscal!==null)
                        {
                            this.docfis.push({
                                id : obj2.doc_fiscal.docfis_id,
                                chave : obj2.doc_fiscal.chave,
                                num_fiscal : obj2.doc_fiscal.num_fiscal,
                                serie : obj2.doc_fiscal.serie,
                                dt_emissao : obj2.doc_fiscal.dt_emissao,
                                emi_nome: obj2.doc_fiscal.doc_fiscal_partes_env.emi_nome,
                                emi_cnpj: obj2.doc_fiscal.doc_fiscal_partes_env.emi_cnpj,
                                des_nome: obj2.doc_fiscal.doc_fiscal_partes_env.des_nome,
                                des_cnpj: obj2.doc_fiscal.doc_fiscal_partes_env.des_cnpj,
                                tp_doc: obj2.doc_fiscal.liv_tp_doc
                            });
                        }
                        else if(obj2.doc_transp!==null)
                        {
                            this.doctransp.push({
                                id : obj2.doc_transp.doctransp_id,
                                chave : obj2.doc_transp.chave,
                                num_fiscal : obj2.doc_transp.num_doc,
                                serie : obj2.doc_transp.serie,
                                dt_emissao : obj2.doc_transp.dt_emissao,
                                emi_nome: obj2.doc_transp.doc_transp_partes_env.emi_nome,
                                emi_cnpj: obj2.doc_transp.doc_transp_partes_env.emi_cnpj,
                                des_nome: obj2.doc_transp.doc_transp_partes_env.des_nome,
                                des_cnpj: obj2.doc_transp.doc_transp_partes_env.des_cnpj,
                                tp_doc: obj2.doc_transp.liv_tp_doc
                            });
                        }
                    });
                });
            }
            else
            {
                this.form.docfis = null;
                this.form.docfis = [];
            }
            this.$refs.modal_associar.show();
        },
        onBuscarDocAssociar(data){
            var c = true;
            data.forEach((obj)=>
            {
                c = true;
                this.docfis.forEach((obj2)=>{
                    if(obj2.id==obj.id)
                    {
                        c = false;
                    }
                });

                if(c)
                {
                    this.docfis.push({
                        id : obj.id,
                        chave : obj.chave,
                        num_fiscal : obj.num_fiscal,
                        serie : obj.serie,
                        dt_emissao : obj.dt_emissao,
                        emi_nome: obj.emi_nome,
                        emi_cnpj: obj.emi_cnpj,
                        des_nome: obj.des_nome,
                        des_cnpj: obj.des_cnpj,
                        tp_doc: obj.tp_doc
                    });
                }
            })
            this.$refs.modal_associar.show();
        },
        onVoltar() {
            this.$refs.modal_associar.show();
        },
        onStoreAssociarDoc()
        {
            var vm = this;
            const onConfirmWrapper = () => {
                confirmFn(vm);
            }

            let confirmFn = function(vm) {
                vm.form.docfis = vm.docfis;
                vm.form.docfisDig = vm.docfisDig;
                vm.form.doctransp = vm.doctransp;
                vm.form.doctranspDig = vm.doctranspDig;
                vm.loading = true;
                vm.isDisabled = true;
                vm.form.post('/api/associar/store/carga').then(response =>
                {
                    vm.docfisDig = null;
                    vm.docfisDig = [];
                    vm.doctranspDig = null;
                    vm.doctranspDig = [];
                    new ReturnApi(response, vm);
                    vm.$emit('reloadvue');
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, vm);
                    vm.errors_array = '';
                    vm.errors_array = [];
                    for(var property in errors)
                    {
                      if(errors.hasOwnProperty(property))
                      {
                         if(typeof(errors[property]) === 'object')
                         {
                         errors[property].forEach((obj)=>{
                            vm.errors_array.push({erro: obj});
                         });
                         }
                      }
                    }
                });
            }

            if(this.helpForm.num_fiscal!="" || this.form_doctransp.num_fiscal!="")
            {
                let obj = {
                    title: 'Atenção!! ',
                    message: 'Existem documentos digitados não adicionados. Deseja descarta-los e prosseguir com a tentativa de associação ?',
                    customConfirmBtnText: 'Sim',
                    customCloseBtnText: 'Não',
                    type: 'info',
                    useConfirmBtn: true,
                    onConfirm: onConfirmWrapper
                }

                this.$Simplert.open(obj);
            }
            else
            {
                confirmFn(this);
            }

        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
              ? ''
              : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        getLivGeral() {
            this.helpForm.get('/api/associar/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.doc_fiscal_tp_doc.forEach((obj)=>
                {
                    this.optionsLivDocFiscalTpDoc.push({ label: obj.descr, value: obj.valor })
                })

                response.doc_transp_tp_doc.forEach((obj)=>
                {
                    this.optionsLivDocTranspTpDoc.push({ label: obj.descr, value: obj.valor })
                })

                response.tp_pessoa.forEach((obj)=>
                {
                    this.optionsLivTpPessoa.push({ label: obj.descr, value: obj.valor })
                })

                response.municipios.forEach((obj)=>
                {
                    this.optionsMunicipios.push({ label: obj.nome, ibge: obj.cd_ibge, value: obj.municipio_id })
                })


            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesFornecedor(search) {
          if(search.length>=3)
          {
              this.isLoadingFor = true;
              this.helpForm.search = search;
              this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
              {
                  this.optionsFornecedor = [];
                  new ReturnApi(response, this, true, false, false);
                  response.items.forEach((obj)=>
                  {
                      this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                  });
                  this.isLoadingFor = false;
              })
              .catch(errors =>
              {
                  new ReturnApi(errors, this)
                });
            }
        },
        removeRowDoc: function(index) {
            this.docfis.splice(index, 1);
        },
        removeRowDocDig: function(index) {
            this.docfisDig.splice(index, 1);
        },
        removeRowDocTransp: function(index) {
            this.doctransp.splice(index, 1);
        },
        removeRowDocTranspDig: function(index) {
            this.doctranspDig.splice(index, 1);
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
            var cnpj_formatado
            var pad = "00000000";
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
            return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
        },
        formatTypedDate: function (dateString)
        {
           let result = dateString.split('/')
           return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
        },
        getCep(en_tipo)
        {
            if(en_tipo==1)
            {
                this.helpForm.cep_busca = this.helpForm.emi_cep;
            }
            else if(en_tipo==2)
            {
                this.helpForm.cep_busca = this.helpForm.des_cep;
            }
            else if(en_tipo==3)
            {
                this.helpForm.cep_busca = this.form_doctransp.emi_cep;
            }
            else if(en_tipo==4)
            {
                this.helpForm.cep_busca = this.form_doctransp.des_cep;
            }

            //Nova variável "cep" somente com dígitos.
            var cep = this.helpForm.cep_busca.replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "")
            {

                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;

                //Valida o formato do CEP.
                if(validacep.test(cep))
                {
                    this.loadingCep = true;
                    this.helpForm.post('/api/cep/pesquisar').then(response =>
                    {
                        new ReturnApi(response, this, true, false, false);

                        if(en_tipo==1)
                        {
                            this.helpForm.errors.clear();
                            response.forEach((obj)=>{
                                this.helpForm.emi_endereco = obj.logradouro;
                                this.helpForm.emi_bairro = obj.bairro;
                                this.helpForm.emi_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.helpForm.emi_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==2)
                        {
                            this.helpForm.errors.clear();
                            response.forEach((obj)=>{
                                this.helpForm.des_endereco = obj.logradouro;
                                this.helpForm.des_bairro = obj.bairro;
                                this.helpForm.des_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.helpForm.des_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==3)
                        {
                            this.form_doctransp.errors.clear();
                            response.forEach((obj)=>{
                                this.form_doctransp.emi_endereco = obj.logradouro;
                                this.form_doctransp.emi_bairro = obj.bairro;
                                this.form_doctransp.emi_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.form_doctransp.emi_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==4)
                        {
                            this.form_doctransp.errors.clear();
                            response.forEach((obj)=>{
                                this.form_doctransp.des_endereco = obj.logradouro;
                                this.form_doctransp.des_bairro = obj.bairro;
                                this.form_doctransp.des_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.form_doctransp.des_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        this.loadingCep = false;

                    })
                    .catch(errors =>
                    {
                        this.loadingCep = false;
                        new ReturnApi(errors, this)
                    });
                }
                else
                {
                    if(en_tipo==1)
                    {
                        var errors = { "errors": { "emi_cep": [ "Cep inválido"] }};
                        this.helpForm.errors.record(errors.errors);
                    }
                    else if(en_tipo==2)
                    {
                        var errors = { "errors": { "des_cep": [ "Cep inválido"] }};
                        this.helpForm.errors.record(errors.errors);
                    }
                    else if(en_tipo==3)
                    {
                        var errors = { "errors": { "emi_cep": [ "Cep inválido"] }};
                        this.form_doctransp.errors.record(errors.errors);
                    }
                    else if(en_tipo==4)
                    {
                        var errors = { "errors": { "des_cep": [ "Cep inválido"] }};
                        this.form_doctransp.errors.record(errors.errors);
                    }
                }
            }
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
